import Enemy from '../objects/enemy';
import Player from '../objects/player';
import wave from '../assets/data/waves';
import Obstacle from '../objects/obstacle';
import Missile from '../objects/missile';
import Loot from '../objects/loot';

import { enemyType, lootType } from '../assets/data/enum';
// import Bullet from '../objects/bullet';
// import { obstacle } from '../assets/loader';
export default class SpawnManager {
    public missiles: Phaser.GameObjects.Group;
    public enemies: Array<Phaser.GameObjects.Group> = [];
    public obstacles: Phaser.GameObjects.Group;
    public loots: Array<Phaser.GameObjects.Group> = [];
    public enemyBullets: Array<Phaser.GameObjects.Group> = [];


    private _container: Phaser.GameObjects.Container;
    private _overHeadContainer: Phaser.GameObjects.Container;
    private _missileSpawnData: any;

    private _obstacleKey: Array<string> = [];
    private _enemyKey: Array<string> = [];
    private _scene: Phaser.Scene;
    private _speed: { [key: string]: number } = {};
    private _health: { [key: string]: number } = {};
    private _lanes: Array<any> = [];
    private _laneCounter: number = 0;
    private _spawnInterval: { [key: string]: number } = {};
    private _lastSpawnTime: { [key: string]: number } = {};
    // private _obstacleSpawnInterval: number;
    private _lastEnemySpawnTime: number = 0;
    private _freeLaneDistance: number = 0;
    private _spawnCount: number = 0;
    private _target: Player;

    private _waveIndex: number = 0;
    private _tankCount: number = 0;
    private _waveCount: number = 0;
    private _spawnRate: number = 1;
    private _miniBossEasyThreshold: number = 1;
    private _active: { [key: string]: boolean } = {};

    private _lootKey: Array<string> = [];
    private _spawnFlag: boolean;

    private _fuelBlastTimer: number;
    private _audio: Array<Phaser.Sound.BaseSound>;
    private _wave: {
        "totalWaveCount": number,
        "tankCount": number,
        "spawnRate": number,
        "onTrafficCount": {
            "buggy": number[],
            "battleTruck": number[],
            "tank": number[],
            "obstacle": number[],
            "missile": number[],
            "ambulance": number[],
        },
        "spawnInterval": {
            "min": number,
            "max": number,
        }
    };

    private _nextEnemyTime: number = 1;
    private _updateCounter: number;
    private _updateCounterMax: number;

    constructor(scene: Phaser.Scene, target: Player, container: Phaser.GameObjects.Container, container2: Phaser.GameObjects.Container) {
        this._container = container;
        this._overHeadContainer = container2;
        this._target = target;
        this._spawnFlag = false;
        this._scene = scene;
        this._fuelBlastTimer = 0;
        this._enemyKey = ["hatchback", "sedan", "buggy", "ambulance", "fuel_truck", "tank", "battle_truck"];
        this._lootKey = ["health", "coin_flip", "shield", "magnet", "split_shooter"];
        // this._spawnRate = 1;

        this._speed = window.constants.DATA.speed;
        this._health = window.constants.DATA.health;
        let fuelTankInterval = Math.ceil(Math.random() * 10);
        if (fuelTankInterval < 5) {
            fuelTankInterval += 5;
        }
        this._spawnInterval = {
            "enemy": 1000,
            "obstacle": 10000,
            "missile": 1000,
            "fuel_truck": fuelTankInterval
        };
        this._lastSpawnTime = {
            "enemy": 0,
            "obstacle": 0,
            "missile": 0
        };

        this._active = {
            "missile": false,
            "tank": false,
            "obstacle": false,
            "battle_truck": false
        }

        this._initMissileSpawnData();

        this._freeLaneDistance = (window.constants.BASE_HEIGHT / 5) * window.devicePixelRatio;
        this._createLanes();
        this._createInitialEnemySet();
        this._createAudioSet();
        // this._spawnEnemy();

        // this._checkEndOfWave();
        this._waveIndex = 0;
        this._wave = JSON.parse(JSON.stringify(wave[this._waveIndex]));
        this._waveCount = this._wave.totalWaveCount;
        this._nextEnemyTime = 0.5;
        this._spawnRate = this._wave.spawnRate;


        this._updateCounter = 3;
        this._updateCounterMax = 3;
        // console.log(wave);
    }

    private _createLanes() {
        let start = Math.floor(window.constants.SCREEN_WIDTH * 0.13);
        let interval = Math.floor(window.constants.SCREEN_WIDTH * 0.153);
        for (let i = 0; i < 5; i++) {
            this._lanes[i] = {
                position: { x: start + (i * interval), y: 0 },
                index: i,
                enemy: null,
                isReservedLane: false
            }
        }
    }

    private _createAudioSet(){
        this._audio = [];
        this._audio[0] = this._scene.sound.add("missile_warning", {
            loop: false,
            volume: window.constants["VOLUME"]
        })
        this._audio[1] = this._scene.sound.add("battle_truck", {
            loop: true,
            volume: window.constants["VOLUME"] * 2
        })
    }

    private _createInitialEnemySet() {
        const MAX_POOL = 20, INTIAL_COUNT = 5;
        for (let i = 0, length = this._enemyKey.length; i < length; i++) {
            let key = enemyType[this._enemyKey[i]];
            let frame = this._enemyKey[i];
            if(frame == "hatchback") {
                frame += "_1";
            }
            this.enemies[key] = this._scene.add.group({
                classType: Enemy,
                maxSize: (this._enemyKey[i] == "sedan" || this._enemyKey[i] == "hatchback")? MAX_POOL : 3,
                runChildUpdate: true,
                createCallback: this._createEnemyCallback.bind(this),
                createMultipleCallback: this._createMultipleEnemyCallback.bind(this),
                defaultKey: "assets",
                defaultFrame: frame
                // defaultKey: this._enemyKey[i],
            });
            this.enemies[key].createMultiple({
                classType: Enemy,
                key: "assets",
                frame: frame,
                // key: this._enemyKey[i],
                quantity: (this._enemyKey[i] == "sedan" || this._enemyKey[i] == "hatchback")? INTIAL_COUNT : 1,
                visible: false,
                active: false,
                setXY: {
                    x: 0,
                    y: 0
                }
            })
        }

        this.obstacles = this._scene.add.group({
            classType: Obstacle,
            // defaultKey: "obstacle",
            defaultKey: "assets",
            maxSize: 5,
            runChildUpdate: true,
            createCallback: this._createObstacleCallback.bind(this),
            createMultipleCallback: this._createMultipleObstacleCallback.bind(this)
        });
        this.obstacles.createMultiple({
            classType: Obstacle,
            key: "assets",
            frame: "obstacle",
            // quantity: 5,
            quantity: 5,
            visible: false,
            active: false,
            setXY: {
                x: 0,
                y: 0
            }
        })

        this.missiles = this._scene.add.group({
            classType: Missile,
            defaultKey: "assets",
            // defaultKey: "missile",
            maxSize: 5,
            runChildUpdate: true,
            createCallback: this._createMissileCallback.bind(this),
            createMultipleCallback: this._createMultipleMissileCallback.bind(this)
        });

        this.missiles.createMultiple({
            classType: Missile,
            key: "assets",
            frame: "missile",
            // key: "missile",
            // quantity: 5,
            quantity: 5,
            visible: false,
            active: false,
            setXY: {
                x: 0,
                y: 0
            }
        });

        for (let i = 0, length = this._lootKey.length; i < length; i++) {
            let key = lootType[this._lootKey[i]];
            this.loots[key] = this._scene.add.group({
                classType: Loot,
                defaultKey: "assets",
                maxSize: 15,
                runChildUpdate: true,
                createCallback: this._createLootCallback.bind(this),
                createMultipleCallback: this._createMultipleLootCallback.bind(this),
            });
            let frame = this._lootKey[i] ;
            if(this._lootKey[i] == "coin_flip") {
                frame += "_0";
            }
            this.loots[key].createMultiple({
                classType: Loot,
                key: "assets",
                frame: frame,
                // quantity: 5,
                quantity: (this._lootKey[i] == "coin_flip")? 5 : 1,
                visible: false,
                active: false,
                setXY: {
                    x: 0,
                    y: 0
                }
            })
        }
    }

    // callbacks start
    private _createMultipleObstacleCallback(obstacles: Obstacle[]) {
        for(let i=0, length = obstacles.length; i < length; i++) {
            this._container.add(obstacles[i]);
            let index = this.obstacles.getLength() - 1;
            obstacles[i].setProperties(this._speed.obstacle, this._lanes[index], this._obstacleEndCallback.bind(this));
            obstacles[i].setDepth(this._container.depth + 1);
        }
    }
    private _createObstacleCallback(obstacle: Obstacle) {
        this._container.add(obstacle);
        let index = this.obstacles.getLength() - 1;
        obstacle.setProperties(this._speed.obstacle, this._lanes[index], this._obstacleEndCallback.bind(this));
        obstacle.setDepth(this._container.depth + 1);
    }

    private _createMultipleMissileCallback(missiles: Missile[]) {
        for(let i=0, length = missiles.length;i<length;i++){
            let missile =  missiles[i];
            let index = this.obstacles.getLength() - 1;
            missile.setProperties(this._speed["missile"], this._lanes[index], this._missileEndCallback.bind(this));
            this._container.add([missile, missile.warning]);
            missile.setDepth(this._container.depth + 5);
            missile.warning.setDepth(this._container.depth + 5);
        }
    }
    private _createMissileCallback(missile: Missile) {
        let index = this.obstacles.getLength() - 1;
        missile.setProperties(this._speed["missile"], this._lanes[index], this._missileEndCallback.bind(this));
        this._container.add([missile, missile.warning]);
        missile.setDepth(this._container.depth + 5);
        missile.warning.setDepth(this._container.depth + 5);
    }

    private _createMultipleEnemyCallback(enemies: Enemy[]){
        for(let i=0, length = enemies.length; i < length; i++) {
            let enemy = enemies[i];
            if (this._laneCounter > 4) {
                this._laneCounter -= 5;
            }
            let target = (enemy.name == "buggy" || enemy.name == "battle_truck" || enemy.name == "tank") ? this._target : null;
            enemy.setProperties(this._health[enemy.name], this._speed[enemy.name], this._lanes[this._laneCounter], target, this._enemyEndCallback.bind(this));
            this._container.add(enemy);
            this._overHeadContainer.add(enemy.explosion);
            enemy.setDepth(this._container.depth + 1);
            enemy.explosion.setDepth(this._overHeadContainer.depth + 2);
            if (target) {
                let bullets = enemy.getBullets();
                if (bullets != false) {
                    this.enemyBullets.push(bullets);
                }
            }
            this._laneCounter++;
        }
    }

    private _createEnemyCallback(enemy: Enemy) {
        this._container.add(enemy);
        if (this._laneCounter > 4) {
            this._laneCounter -= 5;
        }
        let name = enemy.name;
        let target = (name == "buggy" || name == "battle_truck" || name == "tank") ? this._target : null;
        enemy.setProperties(this._health[name], this._speed[name], this._lanes[this._laneCounter], target, this._enemyEndCallback.bind(this));
        this._container.add(enemy);
        this._overHeadContainer.add(enemy.explosion);
        enemy.setDepth(this._container.depth + 1);
        enemy.explosion.setDepth(this._overHeadContainer.depth + 2);
        if (target) {
            let bullets = enemy.getBullets();
            if (bullets != false) {
                this.enemyBullets.push(bullets);
            }
        }
        this._laneCounter++;
    }

    private _createMultipleLootCallback(loots: Loot[]) {
        for(let i=0, length = loots.length; i< length; i++) {
            let loot = loots[i];
            this._container.add(loot);
            loot.setDepth(this._container.depth + 4);
            loot.setProperties(this._speed.loot);
        }
    }

    private _createLootCallback(loot: Loot) {
        this._container.add(loot);
        loot.setDepth(this._container.depth + 4);
        loot.setProperties(this._speed.loot);
    }

    private _missileEndCallback(firstBatch: boolean) {
        if (firstBatch) {
            this._missileSpawnData.batch1.returnCount++;
            if (this._missileSpawnData.batch1.returnCount == this._missileSpawnData.batch1.missileCount) {
                this._spawnMissileBatch(this._missileSpawnData.batch2.lanes, false, 100);
            }
        }
        else {
            this._missileSpawnData.batch2.returnCount++;
            if (this._missileSpawnData.batch2.returnCount >= this._missileSpawnData.batch2.missileCount) {
                this._initMissileSpawnData();
                this._active["missile"] = false;
            }
        }
    }

    private _obstacleEndCallback() {
        this._active["obstacle"] = false;
    }

    private _enemyEndCallback(key: string, lane: any, x: number, y: number, killed: boolean) {
        this._active[key] = false;
        switch (key) {
            case "battle_truck":
                lane.isReservedLane = false;
                this._audio[1].stop();
                break;
            case "fuel_truck":
                let radius = Math.floor(window.constants["BASE_HEIGHT"] * 0.3);
                window.constants["FUEL_TRUCK_BLAST"] = true;
                window.constants["BLAST_RADIUS_MIN"] = Math.round(y - radius);
                window.constants["BLAST_RADIUS_MAX"] = Math.round(y + radius);
                break;
        }
        if(killed) {
            this._spawnLoot(key, x, y);
        }
    }

    // callbacks end
    private _initMissileSpawnData() {
        this._missileSpawnData = {
            "batch1": {
                "lanes": [],
                "returnCount": 0,
                "missileCount": 0
            },
            "batch2": {
                "lanes": [],
                "returnCount": 0,
                "missileCount": 0
            },
            "inProgress": false
        }
    }

    // spawn code start

    private _spawnMissile() {
        if (!this._missileSpawnData.inProgress) {
            // this.missiles.active = true;
            let timeInterval = Math.floor(window.constants.BASE_HEIGHT / this._speed["battle_truck"]);
            this._missileSpawnData.inProgress = true;
            this._active["missile"] = true;
            let batch1Count = Math.ceil(Math.random() * 4);
            let startingLane = Math.floor(Math.random() * 3);
            for (let i = 0, length = this._lanes.length, batch1Limit = startingLane + batch1Count; i < length; i++) {
                if (i >= startingLane && i < batch1Limit) {
                    this._missileSpawnData.batch1.lanes.push(i);
                    this._missileSpawnData.batch1.missileCount++;
                }
                else {
                    this._missileSpawnData.batch2.lanes.push(i);
                    this._missileSpawnData.batch2.missileCount++;
                }
            }
            this._spawnMissileBatch(this._missileSpawnData.batch1.lanes, true, timeInterval);
        }
    }

    private _spawnMissileBatch(lanes: Array<number>, firstBatch: boolean, timeInterval) {

        for (let i = 0, length = lanes.length; i < length; i++) {
            this._lanes[lanes[i]].isReservedLane = true;
        }
        this._audio[0].play();
        (function (_this) {
            setTimeout(function () {
                if(!window.constants["GAME_OVER"] && _this._missileSpawnData.inProgress) {
                    for (let i = 0, length = lanes.length; i < length; i++) {
                        let missile = _this.missiles.getFirstDead(true, _this._lanes[lanes[i]].position.x, _this._lanes[lanes[i]].position.y, "assets", "missile");
                        // let missile = _this.missiles.getFirstDead(true, _this._lanes[lanes[i]].position.x, _this._lanes[lanes[i]].position.y, "missile", null);
                        if (missile) {
                            missile.start(_this._lanes[lanes[i]], firstBatch);
                        }
                    }
                }
            }, timeInterval);
        })(this)
    }

    private _spawnObstacle() {
        // this.obstacles.active = true;
        let obstacleCount = Math.ceil(Math.random() * 2);
        // console.log(obstacleCount);
        let side = Math.floor(Math.random() * 2);
        let startLane = side ? 0 : 5 - obstacleCount;
        this._active["obstacle"] = true;
        for (let i = startLane, length = startLane + obstacleCount; i < length; i++) {
            this._lanes[i].isReservedLane = true;
        }

        (function (_this) {
            setTimeout(function () {
                for (let i = startLane, length = startLane + obstacleCount; i < length; i++) {
                    let obstacle = _this.obstacles.getFirstDead(true, _this._lanes[i].position.x, _this._lanes[i].position.y, "assets", "obstacle");
                    // let obstacle = _this.obstacles.getFirstDead(true, _this._lanes[i].position.x, _this._lanes[i].position.y, "obstacle", null);
                    if (obstacle) {
                        obstacle.start(_this._lanes[i]);
                    }
                }
            }, 2200);
        })(this)

    }

    private _spawnEnemy() {
        let freeLanes = this.GetFreeLanes(this._freeLaneDistance);
        if (freeLanes.length > 0) {
            let index = freeLanes[Math.floor(Math.random() * freeLanes.length)];
            let position = this._lanes[index].position;
            let enemy;
            let enemyKey;
            if (this._spawnCount == this._wave.onTrafficCount.tank[0]) {
                // spawn main boss
                enemyKey = "tank";
                this._tankCount++;
                if(this._wave.onTrafficCount.tank.length > 1) {
                    this._wave.onTrafficCount.tank.shift();
                }
            }
            else if (this._spawnCount == this._wave.onTrafficCount.ambulance[0] && this._spawnCount) {
                // spawn ambulance
                if(this._wave.onTrafficCount.ambulance.length > 1) {
                    this._wave.onTrafficCount.ambulance.shift();
                }
                enemyKey = "ambulance";
            }
            else if (this._spawnCount == this._wave.onTrafficCount.buggy[0] && this._spawnCount) {
                // spawn buggy
                if (!this._active.tank && !this._active.battle_truck) {
                    enemyKey = "buggy";
                    if(this._wave.onTrafficCount.buggy.length > 1) {
                        this._wave.onTrafficCount.buggy.shift();
                    }
                }
            }
            else if (this._spawnCount == this._wave.onTrafficCount.battleTruck[0] && this._spawnCount) {
                // spawn batlle truck
                enemyKey = "battle_truck";
                this._lanes[index].isReservedLane = true;
                this._audio[1].play();
                if(this._wave.onTrafficCount.battleTruck.length > 1){
                    this._wave.onTrafficCount.battleTruck.shift();
                }
            }
            else if (this._spawnCount % 10 == this._spawnInterval["fuel_truck"] && this._spawnCount) {
                // spawn fuel tank
                let fuelTankInterval = Math.ceil(Math.random() * 10);
                if (fuelTankInterval < 5) {
                    fuelTankInterval += 5;
                }
                this._spawnInterval["fuel_truck"] = fuelTankInterval;
                enemyKey = "fuel_truck";
            }
            else {
                // spawn hatchback or sedan
                let enemyIndex = Math.floor(Math.random() * 2);
                if (enemyIndex == 0) {
                    enemyKey = "hatchback";
                }
                else {
                    enemyKey = "sedan";
                }
            }

            if(enemyKey) {
                if(enemyKey == "hatchback") {
                    let variantKey = enemyKey + "_" + Math.ceil(Math.random() * 2);
                    enemy = this._getEnemy("assets", variantKey, position.x, position.y);
                } else {
                    enemy = this._getEnemy("assets", enemyKey, position.x, position.y);
                }
                // enemy = this._getEnemy(enemyKey, null, position.x, position.y);
                this._active[enemyKey] = true;
                if (enemy != null) {
                    enemy.start(this._lanes[index]);
                }
                this._lanes[index].enemy = enemy;
                this._spawnCount++;
            } else {
                return;
            }

        }
        this._checkEndOfWave();
    }

    private _spawnLoot(key, x, y) {
        let lootKey = "";
        let loot = null;
        if (key == "ambulance") {
            // spawn health pack
            lootKey = "health";
        }
        else {
            if (key == "sedan" || key == "hatchback") {
                lootKey = "coin_flip";
            }
            else if (key == "buggy" || key == "battle_truck") {
                let index = Phaser.Math.Between(2, this._lootKey.length - 1);
                lootKey = this._lootKey[index];
            }
            else {
                lootKey = "coin_flip";
            }
        }
        loot = this._getLoot("assets", lootKey, x, y);
        // loot = this._getLoot(lootKey, null, x, y);
        if (loot) {
            loot.start(x, y);
        }
        else {
            // console.log("Loot are exhausted");
        }
    }

    // spawn code end

    private _checkEndOfWave() {
        // console.log(wave.length);
        if (this._spawnCount >= this._wave.totalWaveCount && this._tankCount >= this._wave.tankCount) {
            if (this._waveIndex < (wave.length - 1)) {
                this._waveIndex++;
                this._wave = JSON.parse(JSON.stringify(wave[this._waveIndex]));
                this._waveCount = this._wave.totalWaveCount;
            }
            else {
                this._waveIndex = wave.length - 2;
                this._wave = JSON.parse(JSON.stringify(wave[this._waveIndex]));
                this._waveCount = wave[this._waveIndex].totalWaveCount;
            }
            // console.log("Wave Active: " + this._waveIndex);
            this._spawnCount = 0;
            this._tankCount = 0;
        }
    }

    private _getEnemy(key: string, frame: string, x: number, y: number) {
        // console.log(key)
        let enemy = enemyType[frame]
        if(frame.includes("hatchback")) {
            enemy = enemyType["hatchback"];
        }
        return this.enemies[enemy].getFirstDead(true, x, y, key, frame);
        // return this.enemies[enemyType[key]].getFirstDead(true, x, y, key, frame);
    }

    private _getLoot(key, frame, x, y) {
        let f;
        if(frame == "coin_flip") {
            f += "_0";
        }
        return this.loots[lootType[frame]].getFirstDead(true, x, y, key, f);
        // return this.loots[lootType[key]].getFirstDead(true, x, y, key, f);
    }

    private _stopMissileInProgress() {
        this._audio[0].stop();
        this._missileSpawnData.inProgress = false;
        this._missileSpawnData.batch1.lanes = [];
        this._missileSpawnData.batch1.missileCount = 0;
        this._missileSpawnData.batch1.returnCount = 0;
        this._missileSpawnData.batch2.lanes = [];
        this._missileSpawnData.batch2.missileCount = 0;
        this._missileSpawnData.batch2.returnCount = 0;
    }

    public reset(fullReset: boolean){
        let spawns = [this.enemies, this.loots, this.missiles, this.obstacles];
        for(let i=0, length = spawns.length ;i< length; i++) {
            let spawn = spawns[i];
            if(spawn.constructor == Array) {
                for(let j=0, length2 = spawn.length; j< length2; j++) {
                    this._stopGroupElements(spawn[j]);
                }
            } else {
                this._stopGroupElements(spawn);
            }
        }
        for(let i = 0, length = this._lanes.length; i < length; i++) {
            this._lanes[i].enemy = null;
            this._lanes[i].isReservedLane = null;
        }

        for(let i = 0, keys = Object.keys(this._lastSpawnTime) , length = keys.length; i < length; i++) {
            this._lastSpawnTime[keys[i]] = 0;
        }

        for(let i = 0, keys = Object.keys(this._active) , length = keys.length; i < length; i++) {
            this._active[keys[i]] = false;
        }
        if(fullReset) {
            this._waveIndex = 0;
            this._wave = JSON.parse(JSON.stringify(wave[this._waveIndex]));
            this._spawnRate = this._wave.spawnRate;
        }
        this._spawnCount = 0;
        this._stopMissileInProgress();
    }

    private _stopGroupElements(spawn) {
        let children = spawn.getChildren();
        for(let i =0, length = children.length; i<length; i++) {
            let child = children[i];
            if(child.active) {
                child.stop();
            }
        }
    }

    public GetFreeLanes(distance) {
        let freeLanes = new Array();
        for (let i = 0; i < this._lanes.length; i++) {
            if ((this._lanes[i].enemy == null || this._lanes[i].enemy.y - (this._lanes[i].enemy.height / 2) > distance) && !this._lanes[i].isReservedLane) {
                freeLanes.push(i);
                this._lanes[i].enemy = null;
            }
        }
        return freeLanes;
    }

    // Change the whole update loop. Copnvert the wave into a spawnCOunt based lookup object.

    public update(time, dt) {
        /**
         * create a callback for enemy end, and use it set the active flags
         *
         */
        // this._lastSpawnTime["enemy"] += dt;
        if(!(this._updateCounter--)) {
            this._updateCounter = this._updateCounterMax;
            if (this._spawnFlag) {
                // this._lastSpawnTime["obstacle"] += dt;
                // this._lastSpawnTime["missile"] += dt;
                if(this._wave.onTrafficCount.obstacle.length) {
                    if (this._spawnCount > this._wave.onTrafficCount.obstacle[0]) {
                        // console.log("in spawn obstacle");
                        // this._lastSpawnTime["obstacle"] = 0;
                        if (!this._active.missile && !this._active.tank && !this._active.battle_truck) {
                            this._spawnObstacle();
                            this._wave.onTrafficCount.obstacle.shift();
                            return;
                        }
                    }
                }
                if(this._wave.onTrafficCount.missile.length) {
                    if (this._spawnCount > this._wave.onTrafficCount.missile[0]) {
                        // console.log("in spawn missile");
                        // this._lastSpawnTime["missile"] = 0;
                        if (!this._active.obstacle && !this._active.tank && !this._active.battle_truck) {
                            this._spawnMissile();
                            this._wave.onTrafficCount.missile.shift();
                            return;
                        }
                    }
                }
                if (time - this._lastSpawnTime["enemy"] > this._nextEnemyTime) {
                    this._lastSpawnTime["enemy"] = time;
                    this._nextEnemyTime = (Phaser.Math.Between(this._wave.spawnInterval.min * 100, this._wave.spawnInterval.max * 100)) / 100;
                    // console.log(this._nextEnemyTime);
                    if (!this._active.tank && !this._active.missile) {
                        this._spawnEnemy();
                    }
                }
            }

            if (window.constants["FUEL_TRUCK_BLAST"]) {
                if(!this._fuelBlastTimer) {
                    this._fuelBlastTimer = time;
                }

                if (time - this._fuelBlastTimer >= 0.2) {
                    window.constants["FUEL_TRUCK_BLAST"] = false;
                    this._fuelBlastTimer = 0;
                }
            }
        }

    }

    public stop() {
        this._spawnFlag = false;
        window.constants["GAME_OVER"] = true;
    }

    public start() {
        this._spawnFlag = true;
    }

    public getTargetLane() {
        let start = Math.floor(window.constants.SCREEN_WIDTH * 0.13);
        let interval = Math.floor(window.constants.SCREEN_WIDTH * 0.153);
        let l, r;
        for(let i = 0, length = this._lanes.length; i < length; i++) {
            l = Math.floor((start * (i+1)) - (interval * 0.5));
            r = Math.floor((start * (i+1)) + (interval * 0.5));
            if(this._target.x >= l && this._target.x < r) {
                return this._lanes[i];
            }
        }
        return this._lanes[0];
    }
}